/**
 * Polyfill stable language features. These imports will be optimized by `@babel/preset-env`.
 *
 * See: https://github.com/zloirock/core-js#babel
 */
import 'core-js/stable';
import 'core-js/proposals/reflect-metadata';
import 'regenerator-runtime/runtime';

interface WindowType extends Window {
  global: Window;
}

((window as unknown) as WindowType).global = window;
